import { ThemeOptions } from "@mui/material";

const typography: ThemeOptions["typography"] = {
  fontFamily: ["Montserrat"].join(","),
  h1: {
    fontWeight: 500,
    fontSize: "2rem",
    letterSpacing: "-0.24px",
  },
  h2: {
    fontWeight: 500,
    fontSize: "1.75rem",
    letterSpacing: "-0.24px",
  },
  h3: {
    fontWeight: 500,
    fontSize: "1.5rem",
    letterSpacing: "-0.06px",
  },
  h4: {
    fontWeight: 500,
    fontSize: "1.25rem",
    letterSpacing: "-0.06px",
  },
  h5: {
    fontWeight: 500,
    fontSize: "1rem",
    letterSpacing: "-0.05px",
  },
  h6: {
    fontWeight: 500,
    fontSize: "0.9rem",
    letterSpacing: "-0.05px",
  },
  overline: {
    fontWeight: 500,
  },
};

export default typography;
